import { useState } from "react"
import { useSyncCurrentUser } from "hooks/currentUser.hook"
import { Dropdown } from "../dropdown/Dropdown"
import { LogoutIcon } from "../icons/logout/LogoutIcon"
import { useDestroyToken } from "hooks/api/auth/auth.hook"
import { AxiosError } from "axios"
import { useMessage } from "hooks/message.hook"
import { useFillesTableStore } from "store/table.store"
import { ChangePassword } from "./layout/ChangePassword/ChangePassword"
import { useAuth } from "hooks/api/auth/auth.hook"
import type { MenuProps } from "antd"
import style from "./Userbar.module.scss"

const { UserbarStyle, aboutUser, userEmail, logout, label } = style

export const Userbar = () => {
	const [modalOpen, setModalOpen] = useState(false)

	const { resetSessionStoragePagination } = useFillesTableStore()
	const { logout: logOutUser } = useAuth()

	const { data } = useSyncCurrentUser()
	const { mutate: destroyTokenMutation } = useDestroyToken()
	const { error } = useMessage()

	const name = `${data?.name} ${data?.secondName.charAt(0).toUpperCase()}.`
	const email = data?.email

	const logoutHandle = () => {
		destroyTokenMutation(undefined, {
			onSuccess: () => {
				logOutUser()
				resetSessionStoragePagination()
			},
			onError: (e) => {
				if (e instanceof AxiosError) {
					error("Something went wrong, please try again later")
				}
			},
		})
	}

	const dropdownItems: MenuProps["items"] = [
		{
			key: "1",
			label: (
				<div className={aboutUser}>
					<span className={label}>{name}</span>
					<span className={userEmail}>{email}</span>
				</div>
			),
		},
		{
			type: "divider",
		},
		{
			key: "2",
			label: <span className={label}>Change password</span>,
			onClick: () => setModalOpen(true),
		},
		{
			key: "3",
			label: <span className={label}>Re-set 2FA</span>,
			disabled: true,
		},
		{
			type: "divider",
		},
		{
			key: "4",
			label: (
				<div className={logout}>
					<LogoutIcon />
					<span className={label}>Log out</span>
				</div>
			),
			onClick: logoutHandle,
		},
	]

	return (
		<>
			{data ? (
				<Dropdown items={dropdownItems}>
					<div className={UserbarStyle}>
						<span className={name}>{name}</span>
					</div>
				</Dropdown>
			) : null}
			<ChangePassword isModalOpen={modalOpen} setModalClose={() => setModalOpen(false)} />
		</>
	)
}
